/**
 * Created by Rockerz on 10/10/17.
 */
export class Ajax {

    static Get(url,headers={},data={}){

        return new Promise(function(resolve, reject) {

            const request = new XMLHttpRequest();
            request.onreadystatechange = function(){
                if (request.readyState === XMLHttpRequest.DONE) {
                    if (request.status === 200) {
                        resolve(request.responseText);
                    } else {
                        reject();
                    }
                }
            };

            request.open('GET',url);
            for(var header in headers){
                request.setRequestHeader(header, headers[header]);
            }

            request.send();
        });
    }

    static Post(url,headers={},data={}){

        return new Promise(function(resolve, reject) {

            const request = new XMLHttpRequest();
            request.onreadystatechange = function(){
                if (request.readyState === XMLHttpRequest.DONE) {
                    if (request.status === 200) {
                        resolve(request.responseText);
                    } else {
                        reject();
                    }
                }
            };

            request.open('POST',url);
            for(var header in headers){
                request.setRequestHeader(header, headers[header]);
            }

            request.send(data);
        });
    }

}